import { useEffect, useState } from 'react';

/**
 * Formulaire multi-plages pour exception datée (Gestion mois).
 * Même contrat API que Présences — sans modifier le drawer Présences.
 */
export default function EquipeDateHoursForm({
  dateLabel,
  initialPlages = [{ heureDebut: '09:00', heureFin: '17:00' }],
  saving = false,
  onSubmit,
  onCancel,
}) {
  const [plages, setPlages] = useState(initialPlages);

  useEffect(() => {
    setPlages(initialPlages?.length ? initialPlages : [{ heureDebut: '09:00', heureFin: '17:00' }]);
  }, [initialPlages, dateLabel]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const normalized = plages
      .map((p) => ({
        heureDebut: p.heureDebut?.trim(),
        heureFin: p.heureFin?.trim(),
      }))
      .filter((p) => p.heureDebut && p.heureFin);
    onSubmit?.(normalized);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3 rounded-xl border border-violet-200 bg-violet-50/50 p-4">
      <p className="text-sm font-semibold text-gray-900">Modifier les horaires</p>
      <p className="text-xs text-violet-900">
        Cette modification concerne uniquement le {dateLabel.toLowerCase()}.
      </p>
      <div className="space-y-2">
        {plages.map((plage, idx) => (
          <div key={idx} className="flex flex-wrap items-end gap-2">
            <div>
              <label className="mb-1 block text-xs font-medium text-gray-500">Début</label>
              <input
                type="time"
                required
                value={plage.heureDebut}
                onChange={(e) =>
                  setPlages((prev) =>
                    prev.map((p, i) => (i === idx ? { ...p, heureDebut: e.target.value } : p)),
                  )
                }
                className="rounded-lg border border-gray-200 bg-white px-2 py-1.5 text-sm"
              />
            </div>
            <div>
              <label className="mb-1 block text-xs font-medium text-gray-500">Fin</label>
              <input
                type="time"
                required
                value={plage.heureFin}
                onChange={(e) =>
                  setPlages((prev) =>
                    prev.map((p, i) => (i === idx ? { ...p, heureFin: e.target.value } : p)),
                  )
                }
                className="rounded-lg border border-gray-200 bg-white px-2 py-1.5 text-sm"
              />
            </div>
            {plages.length > 1 ? (
              <button
                type="button"
                className="text-xs font-semibold text-red-600"
                onClick={() => setPlages((prev) => prev.filter((_, i) => i !== idx))}
              >
                Retirer
              </button>
            ) : null}
          </div>
        ))}
      </div>
      <button
        type="button"
        className="text-xs font-semibold text-violet-700 hover:underline"
        onClick={() => setPlages((prev) => [...prev, { heureDebut: '14:00', heureFin: '18:00' }])}
      >
        + Ajouter une plage
      </button>
      <div className="flex flex-wrap gap-2 pt-1">
        <button
          type="submit"
          disabled={saving}
          className="rounded-lg bg-violet-600 px-4 py-2 text-sm font-semibold text-white hover:bg-violet-700 disabled:opacity-60"
        >
          Enregistrer
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="rounded-lg border border-gray-200 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-white"
        >
          Annuler
        </button>
      </div>
    </form>
  );
}
